module.exports = __webpack_public_path__ + "static/media/yuotube_logo_claro.df134ba3.webp";